export class ErrorResponseWrapper<T = string[]> extends Error {
  readonly response: Response;

  constructor(response: Response) {
    super();
    this.response = response;
  }

  async getErrorMessages(): Promise<T> {
    return new Promise<T>((resolve) => {
      this.response
        .json()
        .then((msg: T) => {
          typeof msg === "string" ? resolve([msg] as any) : resolve(msg);
        })
        .catch(() => {
          if (!this.response.ok) {
            const errorMessageFromServer = {
              message: this.response.status + " " + this.response.statusText,
            };
            resolve([errorMessageFromServer] as any);
          } else {
            resolve([] as any);
          }
        });
    });
  }
}
